<!-- @veltra/icons generated sha256:070d8b245d388d2b gen:8 source:src/svg/normal/info-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'InfoFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m.004-11c.323 0 .596.273.596.604a.606.606 0 0 1-.605.596.606.606 0 0 1-.595-.605c0-.322.273-.595.604-.595m.005 2.5c.269 0 .497.231.497.508v4.484a.51.51 0 0 1-.504.508.51.51 0 0 1-.496-.508V7.008a.51.51 0 0 1 .503-.508"
    />
  </svg>
</template>
